import { get_api_path } from "./api";
import axios from "axios";

/**
 * Create the bearer token for the API call
 * @returns The bearer token
 */
const createBearerToken = () => {
	return btoa(encodeURIComponent(new Date().getTime()));
};

/**
 * Transform the application array to feed only necessary data into the status viewer table
 * @param {object} application - The applicaton array received from the backend API
 * @returns {object} - The transformed application object.
 */
const transformApplications = (application) => {
	const enquiry_info = JSON.parse(application.enquiry_info);
	const applicationObject = {
		id: application.id,
		address: enquiry_info.address,
		dateAndTime: enquiry_info.dateAndTime,
		companyName: enquiry_info.companyName,
		application_id: application.application_id,
		enquiry_status: application.enquiry_status,
		current_status: application.current_status,
		application_form: application.application_form,
		documents_upload: application.documents_upload,
		nda_signed: application.nda_signed,
		referral: application?.referral || null,
		referredBy: JSON.parse(application?.referredBy) || null,
		remarks: application?.remarks || null,
	};

	return applicationObject;
};

/**
 * Make API call to list applications from backend.
 *
 * @param {any} queryParams - query params to pass to backend
 *
 * @return {object} - result in response object
 */
export async function get_applications(queryParams) {
	const token = createBearerToken();
	const url = get_api_path("traxxasia", "applications", queryParams);
	const response = await axios.get(url, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": true,
		},
	});
	const applicationsData = response.data.result.models.map(
		transformApplications
	);

	return {
		applications: applicationsData,
		count: response.data.result.meta.count,
	};
}

/**
 * Make API call to search for applications from backend.
 *
 * @param {any} queryParams - query params to pass to backend
 *
 * @return {object} - result in response object
 */
export async function search_applications(queryParams) {
	const token = createBearerToken();
	const url = get_api_path("traxxasia", "search", queryParams);
	const response = await axios.get(url, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": true,
		},
	});
	const applicationsData = response.data.result.models.map(
		transformApplications
	);

	return {
		applications: applicationsData,
	};
}

/**
 * Make API call to update application's current status
 *
 * @param {any} bodyParams - body params to pass to backend
 *
 * @return {object} - result in response object
 */
export async function update_application_current_status(bodyParams) {
	const token = createBearerToken();
	const url = get_api_path("traxxasia", "updateCurrentStatus");
	const response = await axios.post(url, bodyParams, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": true,
		},
	});
	return response.data.result;
}

/**
 * Make API call to update application's current status
 *
 * @return {object} - result in response object
 */
export async function get_analytics() {
	const token = createBearerToken();
	const url = get_api_path("traxxasia", "analytics");
	const response = await axios.get(url, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": true,
		},
	});
	return response.data.result;
}
